import _get from 'lodash/get';

export default function getAvatarUrl(
  source: unknown,
  path = 'avatarAttached',
): string | null {
  return (
    _get(source, `${path}.urls.small`) ||
    _get(source, `${path}.urls.original`) ||
    null
  );
}
